module.exports = __webpack_public_path__ + "img/donante-cdi.d84d8577.png";